
// import React, { useState } from "react";
// import { Link } from "react-router-dom";
// import {
//   Drawer,
//   List,
//   ListItem,
//   ListItemIcon,
//   ListItemText,
//   Collapse,
//   IconButton,
//   Divider,
//   Box,
// } from "@mui/material";
// import { FaBars } from "react-icons/fa6";
// import { RxDashboard } from "react-icons/rx";
// import { BsListCheck } from "react-icons/bs";
// import { MdOutlineQueryStats } from "react-icons/md";
// import { FiLogOut } from "react-icons/fi";
// import { ExpandLess, ExpandMore } from "@mui/icons-material";

// function InvestorSidebar({ isSidebarCollapsed, toggleSidebar }) {
//   const [openStatusSubmenu, setOpenStatusSubmenu] = useState(false);

//   const handleStatusClick = () => {
//     setOpenStatusSubmenu((prevOpen) => !prevOpen);
//   };

//   return (
//     <Drawer
//       variant="permanent"
//       sx={{
//         width: isSidebarCollapsed ? 80 : 300,
//         flexShrink: 0,
//         "& .MuiDrawer-paper": {
//           width: isSidebarCollapsed ? 80 : 300,
//           boxSizing: "border-box",
//           transition: "width 0.3s ease",
//           backgroundColor: "#FFFFFF",
//           color: "#fff",
//           height: "100vh",
//           position: "relative",
//         },
//         "& .MuiListItem-root": {
//           padding: "12px 16px",
//           borderRadius: "8px",
//           margin: "4px 8px",
//           "&:hover": {
//             backgroundColor: "rgba(0, 0, 0, 0.05)",
//           },
//         },
//         "& .MuiListItemIcon-root": {
//           minWidth: 40,
//           color: "#fff",
//         },
//         "& .MuiDivider-root": {
//           backgroundColor: "rgba(0, 0, 0, 0.1)",
//         },
//       }}
//     >
//       {/* Header */}
//       <Box
//         sx={{
//           display: "flex",
//           alignItems: "center",
//           justifyContent: isSidebarCollapsed ? "center" : "space-between",
//           padding: "16px",
//         }}
//       >
//         {!isSidebarCollapsed && (
//           <Box
//             sx={{
//               fontWeight: "bold",
//               fontSize: "16px",
//               color: "#fff",
//               whiteSpace: "nowrap",
//             }}
//           >
//             Elephant Tank
//           </Box>
//         )}
//         <IconButton
//           onClick={toggleSidebar}
//           sx={{
//             color: "#fff",
//           }}
//         >
//           <FaBars />
//         </IconButton>
//       </Box>

//       <Divider />

//       {/* Menu */}
//       <List sx={{ mt: 2 }}>
//         {/* Home */}
//         <ListItem
//           button
//           component={Link}
//           to="/InvestorApp"
//           sx={{
//             backgroundColor: "transparent",
//             "&:hover": { backgroundColor: "rgba(0, 0, 0, 0.05)" },
//           }}
//         >
//           <ListItemIcon>
//             <RxDashboard />
//           </ListItemIcon>
//           {!isSidebarCollapsed && <ListItemText primary="Home" />}
//         </ListItem>

//         {/* Status */}
//         <ListItem
//           button
//           onClick={handleStatusClick}
//           sx={{
//             "&:hover": { backgroundColor: "rgba(0, 0, 0, 0.05)" },
//           }}
//         >
//           <ListItemIcon>
//             <BsListCheck />
//           </ListItemIcon>
//           {!isSidebarCollapsed && <ListItemText primary="Status" />}
//           {!isSidebarCollapsed &&
//             (openStatusSubmenu ? <ExpandLess /> : <ExpandMore />)}
//         </ListItem>

//         {/* Submenu */}
//         <Collapse in={openStatusSubmenu} timeout="auto" unmountOnExit>
//           <List component="div" disablePadding>
//             <ListItem
//               button
//               component={Link}
//               to="/InvestorApp/Inprocess"
//               sx={{
//                 paddingLeft: isSidebarCollapsed ? "24px" : "40px",
//                 "&:hover": { backgroundColor: "rgba(0, 0, 0, 0.05)" },
//               }}
//             >
//               <ListItemText primary="In Process" />
//             </ListItem>
//             <ListItem
//               button
//               component={Link}
//               to="/InvestorApp/Selected"
//               sx={{
//                 paddingLeft: isSidebarCollapsed ? "24px" : "40px",
//                 "&:hover": { backgroundColor: "rgba(0, 0, 0, 0.05)" },
//               }}
//             >
//               <ListItemText primary="Selected" />
//             </ListItem>
//             <ListItem
//               button
//               component={Link}
//               to="/InvestorApp/Cancelled"
//               sx={{
//                 paddingLeft: isSidebarCollapsed ? "24px" : "40px",
//                 "&:hover": { backgroundColor: "rgba(0, 0, 0, 0.05)" },
//               }}
//             >
//               <ListItemText primary="Cancelled" />
//             </ListItem>
//           </List>
//         </Collapse>

//         {/* Tracking */}
//         <ListItem
//           button
//           component={Link}
//           to="/InvestorApp/Tracking"
//           sx={{
//             "&:hover": { backgroundColor: "rgba(0, 0, 0, 0.05)" },
//           }}
//         >
//           <ListItemIcon>
//             <MdOutlineQueryStats />
//           </ListItemIcon>
//           {!isSidebarCollapsed && <ListItemText primary="Tracking" />}
//         </ListItem>
//       </List>

//       {/* Logout */}
//       <Box sx={{ mt: "auto", mb: 2 }}>
//         <ListItem
//           button
//           component={Link}
//           to="/logout"
//           sx={{
//             padding: "12px 16px",
//             borderRadius: "8px",
//             margin: "4px 8px",
//             backgroundColor: "rgba(0, 0, 0, 0.05)",
//             "&:hover": { backgroundColor: "rgba(0, 0, 0, 0.1)" },
//           }}
//         >
//           <ListItemIcon>
//             <FiLogOut />
//           </ListItemIcon>
//           {!isSidebarCollapsed && <ListItemText primary="Logout" />}
//         </ListItem>
//       </Box>
//     </Drawer>
//   );
// }

// export default InvestorSidebar;
// import React, { useState } from "react";
// import { Link, useLocation } from "react-router-dom";
// import {
//   Drawer,
//   List,
//   ListItem,
//   ListItemIcon,
//   ListItemText,
//   Divider,
//   IconButton,
// } from "@mui/material";
// import { RxDashboard } from "react-icons/rx";
// import { FaBars } from "react-icons/fa6";
// import { BsListCheck } from "react-icons/bs";
// import { MdOutlineQueryStats } from "react-icons/md";
// import { FiLogOut } from "react-icons/fi";
// import Logo from "../../images/JPG.jpg"; // Replace with your actual logo path
// import { ExpandLess, ExpandMore, Circle } from "@mui/icons-material";
// import { Collapse } from "@mui/material";

// function InvestorSidebar({ isSidebarCollapsed, toggleSidebar }) {
//   const location = useLocation(); // Get the current location
//   const [selected, setSelected] = useState(location.pathname); // Track selected menu item

//   const handleItemClick = (path) => {
//     setSelected(path); // Update the selected item on click
//   };
//   const [openSublist, setOpenSublist] = useState(false);

//   const handleToggleSublist = () => {
//     setOpenSublist(!openSublist);
//   };

//   return (
//     <Drawer
//       variant="permanent"
//       sx={{
//         width: isSidebarCollapsed ? 80 : 240,
//         flexShrink: 0,
//         "& .MuiDrawer-paper": {
//           width: isSidebarCollapsed ? 80 : 240,
//           boxSizing: "border-box",
//           transition: "width 0.3s ease",
//           backgroundColor: "#FFFFFF", // White background
//           color: "#fff",
//           height: "100vh",
//           position: "relative",
//         },
//         "& .MuiListItem-root": {
//           padding: "12px 16px",
//           borderRadius: "8px",
//           margin: "4px 8px",
//           "&:hover": {
//             backgroundColor: "rgba(0, 0, 0, 0.05)", // Light gray on hover
//           },
//         },
//         "& .MuiListItemIcon-root": {
//           minWidth: 40,
//           color: "#fff",
//         },
//         "& .MuiDivider-root": {
//           backgroundColor: "rgba(0, 0, 0, 0.1)",
//         },
//       }}
//     >
//       <div
//         style={{
//           display: "flex",
//           alignItems: "center",
//           justifyContent: isSidebarCollapsed ? "center" : "flex-start",
//           padding: "20px",
//           backgroundColor: "#FFFFFF",
//         }}
//       >
//         {!isSidebarCollapsed && (
//           <img src={Logo} alt="Logo" style={{ width: "150px", height: "auto" }} />
//         )}
//         {isSidebarCollapsed && (
//           <img src={Logo} alt="Logo" style={{ width: "40px", height: "auto" }} />
//         )}
//         <IconButton
//           onClick={toggleSidebar}
//           sx={{
//             marginLeft: "auto",
//             color: "#fff",
//           }}
//         >
//           <FaBars />
//         </IconButton>
//       </div>

//       <Divider />

//       <List>
//         <ListItem
//           button
//           component={Link}
//           to="/InvestorApp"
//           onClick={() => handleItemClick("/InvestorApp")}
//           sx={{
//             backgroundColor: selected === "/InvestorApp" ? "rgba(0, 0, 0, 0.1)" : "transparent",
//             color: selected === "/InvestorApp" ? "#000" : "#fff",
//           }}
//         >
//           <ListItemIcon>
//             <RxDashboard />
//           </ListItemIcon>
//           {!isSidebarCollapsed && <ListItemText primary="Home" />}
//         </ListItem>

//         <ListItem
//         button
//         onClick={handleToggleSublist}
//         sx={{
//           backgroundColor:
//             selected === "/InvestorApp/Status" ? "rgba(0, 0, 0, 0.1)" : "transparent",
//           color: selected === "/InvestorApp/Status" ? "#000" : "#fff",
//         }}
//       >
//         <ListItemIcon>
//           <BsListCheck />
//         </ListItemIcon>
//         {!isSidebarCollapsed && (
//           <ListItemText primary="Status" />
//         )}
//         {!isSidebarCollapsed && (openSublist ? <ExpandLess /> : <ExpandMore />)}
//       </ListItem>
//       <Collapse in={openSublist} timeout="auto" unmountOnExit>
//         <List component="div" disablePadding>
//           <ListItem
//             button
//             component={Link}
//             to="/InvestorApp/Inprocess"
//             onClick={() => handleItemClick("/InvestorApp/Inprocess")}
//             sx={{
//               pl: 4,
//               backgroundColor:
//                 selected === "/InvestorApp/Pending" ? "rgba(0, 0, 0, 0.1)" : "transparent",
//               color: selected === "/InvestorApp/Pending" ? "#000" : "#fff",
//             }}
//           >
//             <ListItemIcon>
//               <Circle sx={{ fontSize: 8 }} />
//             </ListItemIcon>
//             <ListItemText primary="Pending" />
//           </ListItem>
//           <ListItem
//             button
//             component={Link}
//             to="/InvestorApp/Selected"
//             onClick={() => handleItemClick("/InvestorApp/Selected")}
//             sx={{
//               pl: 4,
//               backgroundColor:
//                 selected === "/InvestorApp/Selected" ? "rgba(0, 0, 0, 0.1)" : "transparent",
//               color: selected === "/InvestorApp/Selected" ? "#000" : "#fff",
//             }}
//           >
//             <ListItemIcon>
//               <Circle sx={{ fontSize: 8 }} />
//             </ListItemIcon>
//             <ListItemText primary="Selected" />
//           </ListItem>
//           <ListItem
//             button
//             component={Link}
//             to="/InvestorApp/Cancelled"
//             onClick={() => handleItemClick("/InvestorApp/Cancelled")}
//             sx={{
//               pl: 4,
//               backgroundColor:
//                 selected === "/InvestorApp/Cancelled" ? "rgba(0, 0, 0, 0.1)" : "transparent",
//               color: selected === "/InvestorApp/Cancelled" ? "#000" : "#fff",
//             }}
//           >
//             <ListItemIcon>
//               <Circle sx={{ fontSize: 8 }} />
//             </ListItemIcon>
//             <ListItemText primary="Cancelled" />
//           </ListItem>
//         </List>
//       </Collapse>
//         <ListItem
//           button
//           component={Link}
//           to="/InvestorApp/Tracking"
//           onClick={() => handleItemClick("/InvestorApp/Tracking")}
//           sx={{
//             backgroundColor: selected === "/InvestorApp/Tracking" ? "rgba(0, 0, 0, 0.1)" : "transparent",
//             color: selected === "/InvestorApp/Tracking" ? "#000" : "#fff",
//           }}
//         >
//           <ListItemIcon>
//             <MdOutlineQueryStats />
//           </ListItemIcon>
//           {!isSidebarCollapsed && <ListItemText primary="Tracking" />}
//         </ListItem>

//         <ListItem
//           button
//           component={Link}
//           to="/InvestorApp/MyInvestment"
//           onClick={() => handleItemClick("/InvestorApp/MyInvestment")}
//           sx={{
//             backgroundColor: selected === "/InvestorApp/MyInvestment" ? "rgba(0, 0, 0, 0.1)" : "transparent",
//             color: selected === "/InvestorApp/MyInvestment" ? "#000" : "#fff",
//           }}
//         >
//           <ListItemIcon>
//             <MdOutlineQueryStats />
//           </ListItemIcon>
//           {!isSidebarCollapsed && <ListItemText primary="MyInvestment" />}
//         </ListItem>
//       </List>

//       <div
//         style={{
//           position: "absolute",
//           bottom: 0,
//           width: "100%",
//           padding: "20px",
//         }}
//       >
//         <ListItem
//           button
//           component={Link}
//           to="/logout"
//           onClick={() => handleItemClick("/logout")}
//           sx={{
//             borderRadius: "8px",
//             backgroundColor: selected === "/logout" ? "rgba(0, 0, 0, 0.1)" : "rgba(0, 0, 0, 0.05)",
//             "&:hover": {
//               backgroundColor: "rgba(0, 0, 0, 0.1)",
//             },
//           }}
//         >
//           <ListItemIcon>
//             <FiLogOut />
//           </ListItemIcon>
//           {!isSidebarCollapsed && <ListItemText primary="Logout" />}
//         </ListItem>
//       </div>
//     </Drawer>
//   );
// }

// export default InvestorSidebar;


// import React, { useState } from "react";
// import { Link, useLocation } from "react-router-dom";
// import {
//   Drawer,
//   List,
//   ListItem,
//   ListItemIcon,
//   ListItemText,
//   Divider,
//   IconButton,
// } from "@mui/material";
// import { RxDashboard } from "react-icons/rx";
// import { FaBars } from "react-icons/fa6";
// import { BsListCheck } from "react-icons/bs";
// import { MdOutlineQueryStats } from "react-icons/md";
// import { FiLogOut } from "react-icons/fi";
// import Logo from "../../images/JPG.jpg"; // Replace with your actual logo path
// import { ExpandLess, ExpandMore, Circle } from "@mui/icons-material";
// import { Collapse } from "@mui/material";

// function InvestorSidebar({ isSidebarCollapsed, toggleSidebar }) {
//   const location = useLocation(); // Get the current location
//   const [selected, setSelected] = useState(location.pathname); // Track selected menu item

//   const handleItemClick = (path) => {
//     setSelected(path); // Update the selected item on click
//   };
//   const [openSublist, setOpenSublist] = useState(false);

//   const handleToggleSublist = () => {
//     setOpenSublist(!openSublist);
//   };

//   return (
//     <Drawer
//       variant="permanent"
//       sx={{
//         width: isSidebarCollapsed ? 80 : 240,
//         flexShrink: 0,
//         "& .MuiDrawer-paper": {
//           width: isSidebarCollapsed ? 80 : 240,
//           boxSizing: "border-box",
//           transition: "width 0.3s ease",
//           background: 'linear-gradient(to right,rgb(1, 23, 32),rgb(1, 45, 65))',  
//                   color: "#fff",
//           // height: "100vh",
//           // position: "relative",
//         },
//         "& .MuiListItem-root": {
//           padding: "12px 16px",
//           borderRadius: "8px",
//           margin: "4px 8px",
//           "&:hover": {
//             backgroundColor: "rgba(231, 222, 222, 0.05)", // Light gray on hover
//           },
//         },
//         "& .MuiListItemIcon-root": {
//           minWidth: 40,
//           color: "#fff",
//         },
//         "& .MuiDivider-root": {
//           backgroundColor: "rgba(0, 0, 0, 0.1)",
//         },
//       }}
//     >
//       <div
//         style={{
//           display: "flex",
//           alignItems: "center",
//           background: 'linear-gradient(to right,rgb(1, 23, 32),rgb(1, 45, 65))',
//                     justifyContent: isSidebarCollapsed ? "center" : "flex-start",
//           padding: "20px",
//           backgroundColor: "#FFFFFF",
//         }}
//       >
//         {!isSidebarCollapsed && (
//           <img src={Logo} alt="Logo" style={{ width: "150px", height: "auto" }} />
//         )}
//         {isSidebarCollapsed && (
//           <img src={Logo} alt="Logo" style={{ width: "40px", height: "auto" }} />
//         )}
//         <IconButton
//           onClick={toggleSidebar}
//           sx={{
//             marginLeft: "auto",
//             color: "#fff",
//           }}
//         >
//           <FaBars />
//         </IconButton>
//       </div>

//       <Divider />

//       <List>
//         <ListItem
//           button
//           component={Link}
//           to="/InvestorApp"
//           onClick={() => handleItemClick("/InvestorApp")}
//           sx={{
//             backgroundColor: selected === "/InvestorApp" ? "rgba(0, 0, 0, 0.1)" : "transparent",
//             color: selected === "/InvestorApp" ? "#fff" : "#fff",
//           }}
//         >
//           <ListItemIcon>
//             <RxDashboard />
//           </ListItemIcon>
//           {!isSidebarCollapsed && <ListItemText primary="Home" />}
//         </ListItem>

//         {/* <ListItem
//         button
//         onClick={handleToggleSublist}
//         sx={{
//           backgroundColor:
//             selected === "/InvestorApp/Status" ? "rgba(0, 0, 0, 0.1)" : "transparent",
//           color: selected === "/InvestorApp/Status" ? "#000" : "#fff",
//         }}
//       >
//         <ListItemIcon>
//           <BsListCheck />
//         </ListItemIcon>
//         {!isSidebarCollapsed && (
//           <ListItemText primary="Status" />
//         )}
//         {!isSidebarCollapsed && (openSublist ? <ExpandLess /> : <ExpandMore />)}
//       </ListItem>
//       <Collapse in={openSublist} timeout="auto" unmountOnExit>
//         <List component="div" disablePadding>
//           <ListItem
//             button
//             component={Link}
//             to="/InvestorApp/Inprocess"
//             onClick={() => handleItemClick("/InvestorApp/Inprocess")}
//             sx={{
//               pl: 4,
//               backgroundColor:
//                 selected === "/InvestorApp/Pending" ? "rgba(0, 0, 0, 0.1)" : "transparent",
//               color: selected === "/InvestorApp/Pending" ? "#000" : "#fff",
//             }}
//           >
//             <ListItemIcon>
//               <Circle sx={{ fontSize: 8 }} />
//             </ListItemIcon>
//             <ListItemText primary="Pending" />
//           </ListItem>
//           <ListItem
//             button
//             component={Link}
//             to="/InvestorApp/Selected"
//             onClick={() => handleItemClick("/InvestorApp/Selected")}
//             sx={{
//               pl: 4,
//               backgroundColor:
//                 selected === "/InvestorApp/Selected" ? "rgba(0, 0, 0, 0.1)" : "transparent",
//               color: selected === "/InvestorApp/Selected" ? "#000" : "#fff",
//             }}
//           >
//             <ListItemIcon>
//               <Circle sx={{ fontSize: 8 }} />
//             </ListItemIcon>
//             <ListItemText primary="Selected" />
//           </ListItem>
//           <ListItem
//             button
//             component={Link}
//             to="/InvestorApp/Cancelled"
//             onClick={() => handleItemClick("/InvestorApp/Cancelled")}
//             sx={{
//               pl: 4,
//               backgroundColor:
//                 selected === "/InvestorApp/Cancelled" ? "rgba(0, 0, 0, 0.1)" : "transparent",
//               color: selected === "/InvestorApp/Cancelled" ? "#000" : "#fff",
//             }}
//           >
//             <ListItemIcon>
//               <Circle sx={{ fontSize: 8 }} />
//             </ListItemIcon>
//             <ListItemText primary="Cancelled" />
//           </ListItem>
//         </List>
//       </Collapse> */}
//         <ListItem
//           button
//           component={Link}
//           to="/InvestorApp/Status"
//           onClick={() => handleItemClick("/InvestorApp/Status")}
//           sx={{
//             backgroundColor: selected === "/InvestorApp/Status" ? "rgba(0, 0, 0, 0.1)" : "transparent",
//             color: selected === "/InvestorApp/Status" ? "#fff" : "#fff",
//           }}
//         >
//           <ListItemIcon>
//             <MdOutlineQueryStats />
//           </ListItemIcon>
//           {!isSidebarCollapsed && <ListItemText primary="Status" />}
//         </ListItem>

//         <ListItem
//           button
//           component={Link}
//           to="/InvestorApp/MyInvestment"
//           onClick={() => handleItemClick("/InvestorApp/MyInvestment")}
//           sx={{
//             backgroundColor: selected === "/InvestorApp/MyInvestment" ? "rgba(0, 0, 0, 0.1)" : "transparent",
//             color: selected === "/InvestorApp/MyInvestment" ? "#fff" : "#fff",
//           }}
//         >
//           <ListItemIcon>
//             <MdOutlineQueryStats />
//           </ListItemIcon>
//           {!isSidebarCollapsed && <ListItemText primary="MyInvestment" />}
//         </ListItem>
//       </List>

//       <div
//         style={{
//           position: "absolute",
//           bottom: 0,
//           width: "100%",
//           padding: "20px",
//         }}
//       >
//         <ListItem
//           button
//           component={Link}
//           to="/logout"
//           onClick={() => handleItemClick("/logout")}
//           sx={{
//             borderRadius: "8px",
//             backgroundColor: selected === "/logout" ? "rgba(0, 0, 0, 0.1)" : "rgba(0, 0, 0, 0.05)",
//             "&:hover": {
//               backgroundColor: "rgba(0, 0, 0, 0.1)",
//             },
//           }}
//         >
//           <ListItemIcon>
//             <FiLogOut />
//           </ListItemIcon>
//           {!isSidebarCollapsed && <ListItemText primary="Logout" />}
//         </ListItem>
//       </div>
//     </Drawer>
//   );
// }

// export default InvestorSidebar;
import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import {
  Drawer,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Divider,
  IconButton,
} from "@mui/material";
import { RxDashboard } from "react-icons/rx";
import { FaBars } from "react-icons/fa6";
import { BsListCheck } from "react-icons/bs";
import { MdOutlineQueryStats } from "react-icons/md";
import { FiLogOut } from "react-icons/fi";
import Logo from "../../landpageimage1/startuplogobaner.png"; // Replace with your actual logo path
import { ExpandLess, ExpandMore, Circle } from "@mui/icons-material";
import { Collapse } from "@mui/material";
 
function InvestorSidebar({ isSidebarCollapsed, toggleSidebar }) {
  const location = useLocation(); // Get the current location
  const [selected, setSelected] = useState(location.pathname); // Track selected menu item
 
  const handleItemClick = (path) => {
    setSelected(path); // Update the selected item on click
  };
  const [openSublist, setOpenSublist] = useState(false);
 
  const handleToggleSublist = () => {
    setOpenSublist(!openSublist);
  };
 
  return (
    <Drawer
      variant="permanent"
      sx={{
        width: isSidebarCollapsed ? 80 : 240,
        flexShrink: 0,
        "& .MuiDrawer-paper": {
          width: isSidebarCollapsed ? 80 : 240,
          boxSizing: "border-box",
          transition: "width 0.3s ease",
          background: 'linear-gradient(to right,rgb(196, 58, 33),rgb(245, 75, 75))',  
                  color: "#fff",
          // height: "100vh",
          // position: "relative",
        },
        "& .MuiListItem-root": {
          padding: "12px 16px",
          borderRadius: "8px",
          margin: "4px 8px",
          "&:hover": {
            backgroundColor: "rgba(243, 4, 4, 0.05)", // Light gray on hover
          },
        },
        "& .MuiListItemIcon-root": {
          minWidth: 40,
          color: "#fff",
        },
        "& .MuiDivider-root": {
          backgroundColor: "rgba(238, 9, 9, 0.1)",
        },
      }}
    >
      <div
        style={{
          display: "flex",
          alignItems: "center",
          background: 'linear-gradient(to right,rgb(228, 49, 18),rgb(65, 5, 1))',
                    justifyContent: isSidebarCollapsed ? "center" : "flex-start",
          padding: "20px",
          backgroundColor: "#FFFFFF",
        }}
      >
        {!isSidebarCollapsed && (
          <img src={Logo} alt="Logo" style={{ width: "150px", height: "auto" }} />
        )}
        {isSidebarCollapsed && (
          <img src={Logo} alt="Logo" style={{ width: "40px", height: "auto" }} />
        )}
        <IconButton
          onClick={toggleSidebar}
          sx={{
            marginLeft: "auto",
            color: "#fff",
          }}
        >
          <FaBars />
        </IconButton>
      </div>
 
      <Divider />
 
      <List>
        <ListItem
          button
          component={Link}
          to="/InvestorApp"
          onClick={() => handleItemClick("/InvestorApp")}
          sx={{
            backgroundColor: selected === "/InvestorApp" ? "rgba(0, 0, 0, 0.1)" : "transparent",
            color: selected === "/InvestorApp" ? "#fff" : "#fff",
          }}
        >
          <ListItemIcon>
            <RxDashboard />
          </ListItemIcon>
          {!isSidebarCollapsed && <ListItemText primary="Home" />}
        </ListItem>
 
        {/* <ListItem
        button
        onClick={handleToggleSublist}
        sx={{
          backgroundColor:
            selected === "/InvestorApp/Status" ? "rgba(0, 0, 0, 0.1)" : "transparent",
          color: selected === "/InvestorApp/Status" ? "#000" : "#fff",
        }}
      >
        <ListItemIcon>
          <BsListCheck />
        </ListItemIcon>
        {!isSidebarCollapsed && (
          <ListItemText primary="Status" />
        )}
        {!isSidebarCollapsed && (openSublist ? <ExpandLess /> : <ExpandMore />)}
      </ListItem>
      <Collapse in={openSublist} timeout="auto" unmountOnExit>
        <List component="div" disablePadding>
          <ListItem
            button
            component={Link}
            to="/InvestorApp/Inprocess"
            onClick={() => handleItemClick("/InvestorApp/Inprocess")}
            sx={{
              pl: 4,
              backgroundColor:
                selected === "/InvestorApp/Pending" ? "rgba(0, 0, 0, 0.1)" : "transparent",
              color: selected === "/InvestorApp/Pending" ? "#000" : "#fff",
            }}
          >
            <ListItemIcon>
              <Circle sx={{ fontSize: 8 }} />
            </ListItemIcon>
            <ListItemText primary="Pending" />
          </ListItem>
          <ListItem
            button
            component={Link}
            to="/InvestorApp/Selected"
            onClick={() => handleItemClick("/InvestorApp/Selected")}
            sx={{
              pl: 4,
              backgroundColor:
                selected === "/InvestorApp/Selected" ? "rgba(0, 0, 0, 0.1)" : "transparent",
              color: selected === "/InvestorApp/Selected" ? "#000" : "#fff",
            }}
          >
            <ListItemIcon>
              <Circle sx={{ fontSize: 8 }} />
            </ListItemIcon>
            <ListItemText primary="Selected" />
          </ListItem>
          <ListItem
            button
            component={Link}
            to="/InvestorApp/Cancelled"
            onClick={() => handleItemClick("/InvestorApp/Cancelled")}
            sx={{
              pl: 4,
              backgroundColor:
                selected === "/InvestorApp/Cancelled" ? "rgba(0, 0, 0, 0.1)" : "transparent",
              color: selected === "/InvestorApp/Cancelled" ? "#000" : "#fff",
            }}
          >
            <ListItemIcon>
              <Circle sx={{ fontSize: 8 }} />
            </ListItemIcon>
            <ListItemText primary="Cancelled" />
          </ListItem>
        </List>
      </Collapse> */}
        {/* <ListItem
          button
          component={Link}
          to="/InvestorApp/Status"
          onClick={() => handleItemClick("/InvestorApp/Status")}
          sx={{
            backgroundColor: selected === "/InvestorApp/Status" ? "rgba(0, 0, 0, 0.1)" : "transparent",
            color: selected === "/InvestorApp/Status" ? "#fff" : "#fff",
          }}
        >
          <ListItemIcon>
            <MdOutlineQueryStats />
          </ListItemIcon>
          {!isSidebarCollapsed && <ListItemText primary="Status" />}
        </ListItem>
  */}
        {/* <ListItem
          button
          component={Link}
          to="/InvestorApp/Interested"
          onClick={() => handleItemClick("/InvestorApp/Interested")}
          sx={{
            backgroundColor: selected === "/InvestorApp/Interested" ? "rgba(0, 0, 0, 0.1)" : "transparent",
            color: selected === "/InvestorApp/Interested" ? "#fff" : "#fff",
          }}
        >
          <ListItemIcon>
            <MdOutlineQueryStats />
          </ListItemIcon>
          {!isSidebarCollapsed && <ListItemText primary="Interested Projects" />}
        </ListItem>
 
  */}
        <ListItem
          button
          component={Link}
          to="/InvestorApp/MyInvestment"
          onClick={() => handleItemClick("/InvestorApp/MyInvestment")}
          sx={{
            backgroundColor: selected === "/InvestorApp/MyInvestment" ? "rgba(0, 0, 0, 0.1)" : "transparent",
            color: selected === "/InvestorApp/MyInvestment" ? "#fff" : "#fff",
          }}
        >
          <ListItemIcon>
            <MdOutlineQueryStats />
          </ListItemIcon>
          {!isSidebarCollapsed && <ListItemText primary="Ideas" />}
        </ListItem>
      </List>
 
      <div
        style={{
          position: "absolute",
          bottom: 0,
          width: "100%",
          padding: "20px",
        }}
      >
        {/* <ListItem
          button
          component={Link}
          to="/logout"
          onClick={() => handleItemClick("/logout")}
          sx={{
            borderRadius: "8px",
            backgroundColor: selected === "/logout" ? "rgba(0, 0, 0, 0.1)" : "rgba(0, 0, 0, 0.05)",
            "&:hover": {
              backgroundColor: "rgba(0, 0, 0, 0.1)",
            },
          }}
        >
          <ListItemIcon>
            <FiLogOut />
          </ListItemIcon>
          {!isSidebarCollapsed && <ListItemText primary="Logout" />}
        </ListItem> */}
      </div>
    </Drawer>
  );
}
 
export default InvestorSidebar;